/**
 * Contexto del shell Workspace 0E3.
 * POS-UX-CONTROL-RECOVERY-001: sidebar expandible/colapsable.
 */
import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';

const WorkspaceShellContext = createContext(null);
const NAV_EXPANDED_KEY = 'e0e3_pos_nav_expanded';

export function WorkspaceShellProvider({ children }) {
  const [commandPaletteReady] = useState(true);
  const [commandPaletteOpen, setCommandPaletteOpen] = useState(false);
  const [focusMode, setFocusMode] = useState(false);
  const [flyoutOpen, setFlyoutOpen] = useState(false);
  const [navExpanded, setNavExpanded] = useState(() => {
    try {
      const raw = localStorage.getItem(NAV_EXPANDED_KEY);
      if (raw === null) return true; // expandido por defecto (labels visibles)
      return raw === '1' || raw === 'true';
    } catch {
      return true;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(NAV_EXPANDED_KEY, navExpanded ? '1' : '0');
    } catch {
      /* ignore */
    }
  }, [navExpanded]);

  const openCommandPalette = useCallback(() => {
    setCommandPaletteOpen(true);
  }, []);

  const closeCommandPalette = useCallback(() => {
    setCommandPaletteOpen(false);
  }, []);

  const toggleFocusMode = useCallback(() => {
    setFocusMode((prev) => !prev);
  }, []);

  const toggleNavExpanded = useCallback(() => {
    setNavExpanded((prev) => !prev);
  }, []);

  const value = useMemo(() => ({
    commandPaletteReady,
    commandPaletteOpen,
    setCommandPaletteOpen,
    openCommandPalette,
    closeCommandPalette,
    focusMode,
    setFocusMode,
    toggleFocusMode,
    flyoutOpen,
    setFlyoutOpen,
    navExpanded,
    setNavExpanded,
    toggleNavExpanded
  }), [
    commandPaletteReady,
    commandPaletteOpen,
    openCommandPalette,
    closeCommandPalette,
    focusMode,
    toggleFocusMode,
    flyoutOpen,
    navExpanded,
    toggleNavExpanded
  ]);

  return (
    <WorkspaceShellContext.Provider value={value}>
      {children}
    </WorkspaceShellContext.Provider>
  );
}

export function useWorkspaceShell() {
  const ctx = useContext(WorkspaceShellContext);
  if (!ctx) {
    throw new Error('useWorkspaceShell debe usarse dentro de WorkspaceShellProvider');
  }
  return ctx;
}

export default WorkspaceShellContext;
